import { render, staticRenderFns } from "./CanadaFrontOfPackConfiguration.vue?vue&type=template&id=311395a9&scoped=true"
import script from "./CanadaFrontOfPackConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanadaFrontOfPackConfiguration.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311395a9",
  null
  
)

export default component.exports